/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { Column } from "components/styles";
import { Title } from "views/components/Schedules/components/UpdateActivityPopup/styles";
import ActionButtons from "./ActionButtons";
import StudentTableList from "./StudentTableList/StudentTableList";
import DialogPenalizeForm from "../PenalizeDialog";
import DialogSearchStudent from "views/components/DialogSearchStudent/DialogSearchStudent";
import DialogAddStudentConfirmation from "./AddStudentDialogs/DialogAddStudentConfirmation";
import DialogDeleteStudentConfirmation from "./DeleteStudentDialogs/DialogDeleteStudentConfirmation";
import DialogStudentTakeAttendanceConfirmation from "./TakeAttendanceDialogs/DialogStudentTakeAttendanceConfirmation";
import DialogSaveInformationConfirmation from "./DialogSaveInformationConfirmation";
import DialogNotDeleteForLessThanTwoStudentsRemaining from "./DeleteStudentDialogs/DialogNotDeleteForLessThanTwoStudentsRemaining";
import DialogNotUpdatePenaltyBecauseStudentsHaveDiferentPenalties from "./DialogNotUpdatePenaltyBecauseStudentsHaveDiferentPenalties";
import DialogNotActionForHaveAttendanceOrPenalty from "./DialogNotActionForHaveAttendanceOrPenalty";
import DialogMinCapacityReached from "./DialogMinCapacityReached";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import useMainContext from "utils/context/useMainContext";
import useRemoveScrollByDialogs from "./utils/hooks/useRemoveScrollByDialogs";
import useAddStudent from "./utils/hooks/useAddStudent";
import useDeleteStudents from "./utils/hooks/useDeleteStudents";
import useTakeStudentAttendance from "./utils/hooks/useTakeStudentAttendance";
import usePenalizedStudents from "./utils/hooks/usePenalizeStudents";
import useActionTypes from "./utils/hooks/useActionTypes";
import useStudentList from "./utils/hooks/useStudentList";
import useSelectedStudents from "./utils/hooks/useSelectedStudents";
import useSaveReservationStudentInformation from "./utils/hooks/useSaveReservationStudentInformation";
import useResourcesUniversitySpacesContext from "views/Recursos/ResourcesUniversitySpaces/utils/context/useResourcesUniversitySpacesContext";
import DialogStudentAddedSuccessfully from "./AddStudentDialogs/DialogStudentAddedSuccessfully";
import DialogStudentAlreadyAdded from "./AddStudentDialogs/DialogStudentAlreadyAdded";
import DialogDeleteStudentSuccessfully from "./DeleteStudentDialogs/DialogDeleteStudentSuccessfully";
import useActionTypeCleaner from "./utils/hooks/useActionTypeCleaner";
import DialogAddStudentError from "./AddStudentDialogs/DialogAddStudentError";
import DialogCannotResponsibleTakeAttendanceUntilStartTime from "./TakeAttendanceDialogs/DialogCannotResponsibleTakeAttendanceUntilStartTime";

const StudentListReservationView = ({
    data, space, reservation,
    updateActivityPopup,
}) => {
    const mainContext = useMainContext();
    const { loadingRequestOfReservationAction } = useResourcesUniversitySpacesContext();
    //#region States
    const [studentsSelectedToUse, setStudentsSelectedToUse] = useState([]);
    //#endregion
    const dialogSearchStudent = useShowDialogAlert();
    const dialogShowNotActionForHavingAttendanceOrPenalty = useShowDialogAlert();
    const studentList = useStudentList({
        updateActivityPopup, reservation
    });
    const selectedStudents = useSelectedStudents({
        studentList, reservation
    });
    //#endregion
    //#region Custom hooks
    const {
        actionTypeList,
        actionTypeOfNoActionForHaveAttendanceOrPenalty
    } = useActionTypes({
        setMustConfirm: updateActivityPopup.mustConfirm.set
    });
    const addActionTypeToListActions = actionTypeList.add;
    const {
        fns: {
            openTakeStudentAttendanceDialog,
            takeStudentAttendance,
            doRequestTakeStudentAttendance
        },
        dialogs: {
            dialogTakeStudentsAttendanceConfirmation,
            dialogCannotResponsibleTakeAttendanceUntilStartTime
        }
    } = useTakeStudentAttendance({
        selectedStudents,
        addActionTypeToListActions,
        reservation
    });
    const penalizedStudents = usePenalizedStudents({
        data, space,
        selectedStudents,
        addActionTypeToListActions,
        dialogs: {
            dialogShowNotActionForHavingAttendanceOrPenalty
        },
        setActionTypeOfNoActionForHaveAttendanceOrPenalty: actionTypeOfNoActionForHaveAttendanceOrPenalty.set,
    });
    const {
        formList,
        dialogs: {
            dialogShowNotUpdatePenaltyBecauseStudentsHaveDiferentPenalties,
            dialogPenalizeForm
        },
        studentsWithRegisteredPenalty,
        fns: {
            openPenalizeStudentDialog,
            doRequestPenalizeStudents,
            isForUpdatePenalty,
            getInfoTooltipOfPenalize
        }
    } = penalizedStudents;
    const {
        studentReservationDetailIdsToDelete,
        studentsWithPenaltyOrAttendanceForDeletion,
        fns: {
            deleteStudentsFromReservationList,
            openDeleteStudentDialog,
            doRequestDeleteStudentFromReservationList,
        },
        dialogs: {
            dialogShowDeleteStudentsConfirmation,
            dialogShowNotDeleteForMinStudentsRemaining,
            dialogMinCapacityReached,
            dialogDeleteStudentSuccessfully
        }
    } = useDeleteStudents({
        selectedStudents,
        setStudentsSelectedToUse,
        dialogs: {
            dialogShowNotActionForHavingAttendanceOrPenalty
        },
        setActionTypeOfNoActionForHaveAttendanceOrPenalty: actionTypeOfNoActionForHaveAttendanceOrPenalty.set,
        addActionTypeToListActions
    });
    const {
        fns: {
            addStudentToReservationList,
            confirmAddStudent,
            doRequestAddStudentToReservationList
        },
        dialogs: {
            dialogAddStudentConfirmation,
            dialogStudentAddedSuccessfully,
            dialogStudentAlreadyAdded, 
            dialogAddStudentError
        }
    } = useAddStudent({
        reservationId: reservation.id,
        studentList,
        studentsSelectedToUse,
        setStudentsSelectedToUse,
        addActionTypeToListActions,
    });
    const saveReservationStudentInformation = useSaveReservationStudentInformation({
        updateActivityPopup,
        actionTypeList,
        requests: {
            doRequestAddStudentToReservationList,
            doRequestDeleteStudentFromReservationList,
            doRequestPenalizeStudents,
            doRequestTakeStudentAttendance
        }
    })
    useRemoveScrollByDialogs([
        mainContext.showDialogUnexpectedError,
        dialogPenalizeForm.value,
        dialogShowNotActionForHavingAttendanceOrPenalty.value,
        dialogShowNotDeleteForMinStudentsRemaining.value,
        dialogShowNotUpdatePenaltyBecauseStudentsHaveDiferentPenalties.value,
        dialogShowDeleteStudentsConfirmation.value,
        saveReservationStudentInformation.dialogConfirm.value
    ]);
    useActionTypeCleaner({
        actionTypeList, studentList,
        studentReservationDetailIdsToDelete,
        dialogs: [
            dialogStudentAddedSuccessfully,
            dialogStudentAlreadyAdded,
            dialogDeleteStudentSuccessfully
        ]
    });
    //#endregion
    return (
        <>
            <Column gap="10px">
                <Title title="Listado de alumnos">Listado de alumnos</Title>
                <StudentTableList
                    data={studentList.value}
                    formList={formList}
                    selectedStudents={selectedStudents}
                    getInfoTooltipOfPenalize={getInfoTooltipOfPenalize} />
                <ActionButtons
                    studentList={studentList}
                    selectedStudents={selectedStudents}
                    isForUpdatePenalty={isForUpdatePenalty}
                    notActions={actionTypeList.noActions()}
                    finalized={reservation.finalized}
                    actions={{
                        openTakeStudentAttendanceDialog,
                        openPenalizeStudentDialog,
                        openDeleteStudentDialog,
                        openAddStudentDialog: dialogSearchStudent.open,
                        openSaveInformationDialog: saveReservationStudentInformation.dialogConfirm.open,
                    }} />
            </Column>
            <DialogSearchStudent
                loadingRequest={loadingRequestOfReservationAction}
                dialogShow={dialogSearchStudent}
                changeStudent={confirmAddStudent} />
            <DialogPenalizeForm
                data={data}
                penalizedStudents={penalizedStudents} />
            <DialogAddStudentConfirmation
                dialog={dialogAddStudentConfirmation}
                space={reservation.space}
                studentsSelectedToUse={studentsSelectedToUse}
                addStudentToReservationList={addStudentToReservationList} />
            <DialogAddStudentError dialog={dialogAddStudentError}/>
            <DialogDeleteStudentConfirmation
                dialog={dialogShowDeleteStudentsConfirmation}
                space={reservation.space}
                selectedStudents={selectedStudents}
                deleteStudentsFromReservationList={deleteStudentsFromReservationList} />
            <DialogStudentTakeAttendanceConfirmation
                dialog={dialogTakeStudentsAttendanceConfirmation}
                selectedStudents={selectedStudents}
                takeStudentAttendance={takeStudentAttendance} />
            <DialogCannotResponsibleTakeAttendanceUntilStartTime
                dialog={dialogCannotResponsibleTakeAttendanceUntilStartTime}/>
            <DialogSaveInformationConfirmation {...saveReservationStudentInformation} />
            {studentsSelectedToUse.length > 0 &&
                <>
                    <DialogStudentAddedSuccessfully
                        dialog={dialogStudentAddedSuccessfully}
                        studentsSelectedToUse={studentsSelectedToUse}
                        space={reservation.space} />
                    <DialogStudentAlreadyAdded
                        dialog={dialogStudentAlreadyAdded}
                        studentsSelectedToUse={studentsSelectedToUse} />
                    <DialogDeleteStudentSuccessfully
                        dialog={dialogDeleteStudentSuccessfully}
                        space={reservation.space}
                        studentsSelectedToUse={studentsSelectedToUse} />
                </>}
            <DialogMinCapacityReached
                dialog={dialogMinCapacityReached}
                space={reservation.space} />
            <DialogNotDeleteForLessThanTwoStudentsRemaining
                dialog={dialogShowNotDeleteForMinStudentsRemaining} />
            <DialogNotUpdatePenaltyBecauseStudentsHaveDiferentPenalties
                dialog={dialogShowNotUpdatePenaltyBecauseStudentsHaveDiferentPenalties} />
            <DialogNotActionForHaveAttendanceOrPenalty
                dialog={dialogShowNotActionForHavingAttendanceOrPenalty}
                actionTypeOfNoActionForHaveAttendanceOrPenalty={actionTypeOfNoActionForHaveAttendanceOrPenalty}
                studentsWithPenaltyOrAttendanceForDeletion={studentsWithPenaltyOrAttendanceForDeletion}
                studentsWithRegisteredPenalty={studentsWithRegisteredPenalty} />
        </>
    );
}

export default StudentListReservationView;